import { render, staticRenderFns } from "./ChangePasswordModal.vue?vue&type=template&id=1c012720"
import script from "../../../scripts/partials/ChangePasswordModal.js?vue&type=script&lang=js&external"
export * from "../../../scripts/partials/ChangePasswordModal.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports